/* eslint-disable */
import { SkeletonWrapper } from '@/components/SkeletonWrapper';
import { Box } from '@mui/material';
import { ReactNode } from 'react';

import {
  Badge,
  CardContent,
  CardTitle,
  ContentLabel,
  ContentValue,
} from './styles';

export type CardData = {
  label: string;
  labelBadge?: ReactNode;
  value: string | number | boolean;
  valueElement?: ReactNode;
  user_status?: 'active' | 'inactive';
};

interface CardProps {
  title?: string;
  cardData: CardData[];
  qtdItems?: number;
  isLoading: boolean;
}

export function Card({
  title,
  cardData,
  qtdItems,
  isLoading,
}: CardProps): JSX.Element {
  const itemsLenght = qtdItems || 6;
  return (
    <Box sx={{ width: '100%' }}>
      <CardTitle>{title}</CardTitle>
      <CardContent>
        {!isLoading
          ? cardData?.map((data) => (
              <div key={data.label} className="card-data">
                <ContentLabel>
                  {data.label}
                  {data.labelBadge}
                </ContentLabel>
                <ContentValue>
                  {data.user_status && <Badge status={data.user_status} />}
                  {data.valueElement
                    ? data.valueElement
                    : data.user_status
                    ? data.user_status === 'active'
                      ? 'Ativo'
                      : 'Inativo'
                    : data.value}
                </ContentValue>
              </div>
            ))
          : Array.from({ length: itemsLenght }).map((_, index) => (
              <div className="card-data">
                <SkeletonWrapper
                  key={index}
                  isLoading={isLoading}
                  variant="rectangular"
                  height={16}
                  width={64}
                />
                <SkeletonWrapper
                  key={index}
                  isLoading={isLoading}
                  variant="rectangular"
                  height={16}
                  width={128}
                />
              </div>
            ))}
      </CardContent>
    </Box>
  );
}
